<div class="relative" #filterWrapper>

    <button class="flex items-center gap-2 font-medium text-base px-5 py-2 rounded-2xl cursor-pointer transition
         border text-(--brand-primary) border-(--brand-primary)" [ngClass]="{
      'bg-blue-50': filterClicked,
      'text-white border-transparent': applied && !filterClicked && !isDefaultState()
  }" [ngStyle]="{
      'background': applied && !filterClicked && !isDefaultState()
        ? 'var(--btn-bg-gradient)'
        : (filterClicked ? 'rgb(239 246 255)' : 'transparent')
  }" (click)="toggleFilter()">
        <!-- Icon -->
        <img [src]="applied && !filterClicked && !isDefaultState()
        ? 'assets/icons/filter-white.svg'
        : 'assets/icons/filter.svg'" class="w-5 h-5" />

        <!-- Label -->
        {{
        (applied && !filterClicked && !isDefaultState())
        ? getSelectedSortLabel()
        : ('TABLE.FILTERS' | translate)
        }}

        <!-- Count Bubble -->
        <span *ngIf="applied && !filterClicked && getCheckedCount() > 0 && !isDefaultState()"
            class="ml-1 bg-white text-(--brand-primary) font-semibold w-6 h-6 flex items-center justify-center rounded-full">
            {{ getCheckedCount() }}
        </span>
    </button>

    <!-- DROPDOWN -->
    <div class="absolute sm:w-[460px] w-[280px] bg-white rounded-2xl shadow-(--shadow-input) mt-3 p-4 rtl:left-0 rtl:right-auto right-0 z-10 transition-all duration-300 origin-top"
        *ngIf="filterClicked" [class.opacity-100]="filterClicked" [class.opacity-0]="!filterClicked"
        [class.scale-y-100]="filterClicked" [class.scale-y-0]="!filterClicked">

        <!-- Title + Buttons -->
        <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold text-(--text-primary)">{{'TABLE.FILTERS' | translate}}</h3>

            <div class="flex items-center gap-4 text-base font-medium">
                <button class="text-(--brand-primary) rounded-xl py-1 px-3 border cursor-pointer hover:bg-blue-50"
                    [class.opacity-40]="disableApply" [class.pointer-events-none]="disableApply" (click)="onApply()">
                    {{'TABLE.APPLY' | translate}}
                </button>

                <button *ngIf="showReset" class="click-text cursor-pointer" (click)="onReset()">
                    {{'TABLE.RESET' | translate}}
                </button>
            </div>
        </div>

        <div class="border-b-[0.5px] border-gray-200 mb-4"></div>

        <!-- CATEGORIES -->
        <div *ngFor="let category of filterOptions" class="mb-6">

            <div *ngIf="category.category" class="text-medium text-(--text-muted)! mb-3">
                {{ category.category | translate }}
            </div>

            <div *ngFor="let opt of category.options" class="flex justify-between items-center py-2 pl-3 cursor-pointer"
                (click)="category.type === 'radio' ? onRadioSelect(category, opt) : toggleCheck(opt)">

                <span class="text-medium">
                    {{ opt.label | translate}}
                </span>

                <!-- RADIO -->
                <div *ngIf="category.type === 'radio'"
                    class="w-6 h-6 rounded-full border flex items-center justify-center transition-colors duration-200"
                    [ngClass]="{
       'border-(--text-placeholder)': !opt.checked,
       'border-(--brand-primary)': opt.checked,
       'bg-(--brand-primary)': opt.checked
     }" (click)="onRadioSelect(category, opt)">
                    <div *ngIf="opt.checked" class="w-3 h-3 rounded-full bg-white"></div>
                </div>


                <!-- CHECKBOX -->
                <div *ngIf="category.type === 'check'"
                    class="w-6 h-6 flex items-center justify-center rounded-full border-2 transition-all" [ngClass]="{
       'bg-(--brand-primary) border-(--brand-primary)': opt.checked,
       'border-(--text-placeholder)': !opt.checked
     }">

                    <img *ngIf="opt.checked" src="assets/icons/check-white.svg" alt="checked" class="w-3.5 h-3.5" />
                </div>

            </div>

        </div>

    </div>
</div>